<div mat-dialog-title class="dialog-info">
    <label class="dialogTitle">
       {{'REQUEST_EDITOR_ACCESS' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none crossButtonPosition" [mat-dialog-close]></button>
</div>

<div class="row m-0">
    <div class="row p-0 m-0" [formGroup]="reqEditorAccessFormGroup">
         <mat-dialog-content class="contentPadding">
            <section>
                <mat-label class="bold">
                    {{'ENTER_REQUEST_NOTES' | translate}}
                </mat-label>
            </section>
            <section>
                <textarea class="customize-textbox"
                placeholder="{{'ENTER_REQUEST_NOTES_PLACEHOLDER' | translate}}"
                formControlName="changeLogNotes"></textarea>
            </section>
           <section class="req-editor-access-section-checkbox">
            <mat-checkbox color="primary" class="example-margin" formControlName="sendEmail">{{'NOTIFY_COLLABORATORS' | translate}}</mat-checkbox>
           </section>
        </mat-dialog-content>

        <mat-dialog-actions align="end" class="contentPadding">
            <div>
                <button class="openCloseBtn" mat-raised-button color="primary" 
                        (click)="requestAccess()" 
                        [disabled]="!canRequestAccess">
                        {{'REQUEST' | translate}}
                </button>
                <button class="openCloseBtn" mat-raised-button color="warn" 
                        [mat-dialog-close]>
                        {{'CANCEL' | translate}}
                </button>
            </div>
        </mat-dialog-actions>
    </div>
</div>